import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Lesson } from 'core/models/course-content.model';
import { LessonHeader } from 'components/lesson-header/lesson-header';

@Component({
  selector: 'app-evaluation-preview',
  standalone: true,
  imports: [CommonModule, LessonHeader],
  templateUrl: './evaluation-preview.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'w-full h-full flex flex-col',
  },
})
export class EvaluationPreview {
  @Input({ required: true }) lesson!: Lesson;

  protected get evaluationData() {
    return this.lesson?.evaluationData;
  }

  protected get questions() {
    return this.evaluationData?.questions || [];
  }
}
